export const withSaveState = ($table, options) => {
  const dataState = $table.data('state');
  let state;
  if (dataState) {
    state = dataState.datatable_state.state;
  }
  const stateUrl = $table.data('state-url');
  return stateUrl
    ? {
      ...options,
      stateSave: true,
      stateSaveCallback(settings, data) {
        $.ajax({
          type: 'PATCH',
          dataType: 'json',
          url: stateUrl,
          data: {
            datatable_state: {
              state: JSON.stringify(data)
            }
          }
        });
      },
      stateLoadCallback(settings, callback) {
        if (state) {
          setTimeout(() => {
            callback(JSON.parse(state));
          }, 0);
        } else {
          $.ajax({
            url: stateUrl,
            dataType: 'json',
            success(json) {
              callback(JSON.parse(json.datatable_state.state));
            }
          });
        }
      }
      // The search term is restored from DatatableState like every other
      // saved column/sort/page setting -- no stateLoadParams override here.
      // Since DatatableState is keyed by user_id + organization_id + table
      // name, this naturally scopes the persisted term to the logged-in
      // user's session: it survives page navigation but not a login as a
      // different user, and a signed-out visitor has no state to load at all.
    }
    : options;
};
